<template>
  <div class="item">
    <div
      :class="{ 'img-icon': data.charge == 1, 'img-icon-sp': data.charge == 2 }"
    >
      <img class="img" :src="dataTypeList[dataType]?data.displayBigPhoto:data.displaySmallPhoto" alt="" />
    </div>
    <div class="content">
      <h3>{{ data.name }}</h3>
      <p class="twoline">
        {{ dataTypeList[dataType] ? data.indexDescription : data.description }}
      </p>
      <div class="label-content" >
        <!-- <div class="price" v-if="data.goods">￥{{data.goods.price}}</div> -->
        <div class="count">
          <img v-if="dataType == 4" src="/images/goods/topic4.png" alt="" />
          <img v-else src="/images/goods/topic2.png" alt="" />{{
            (data.fakeBrowseCount + data.browseCount) | countOmit
          }}
        </div>
        <ul class="labels" v-if="!data.goods">
          <template v-for="(item, index) in data.tags">
            <li :key="index" v-if="index < 2">{{ item }}</li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
const dataTypeList = { 4: 'video' }
import { countOmit } from '@/filters/browseCountOmit'
export default {
  filters: { countOmit },
  props: {
    dataType:{
      default:4,
      type:Number
    },
    data: Object
  },
  data () {
    return {
      dataTypeList
    }
  }
}
</script>
<style scoped>
.item {
  display: flex;
  margin: 0 10px;
  position: relative;
}
.item .img {
  display: block;
  width: 94px;
  height: 94px;
  flex: 0 0 auto;
  margin-right: 17px;
  border-radius: 8px;
  position: relative;
}
.item .img-icon {
  position: relative;
}
.item .img-icon::before {
  content: '';
  width: 24px;
  height: 24px;
  position: absolute;
  left: 0;
  top: 0;
  background: url('/images/goods/vip_icon_free.png') no-repeat;
  background-size: 100% 100%;
  border-top-left-radius: 8px;
  z-index: 2;
}
.item .img-icon-sp {
  position: relative;
}
.item .img-icon-sp::before {
  content: '';
  width: 24px;
  height: 24px;
  position: absolute;
  left: 0;
  top: 0;
  background: url('/images/goods/vip_icon_free2.png') no-repeat;
  background-size: 100% 100%;
  border-top-left-radius: 8px;
  z-index: 2;
}
.item .content {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}
.item h3 {
  font-size: 14px;
  color: rgba(36, 67, 82, 1);
  line-height: 20px;
}
.item p {
  font-size: 12px;
  color: rgba(106, 146, 164, 1);
  line-height: 17px;
}
.twoline {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.item .label-content {
  display: flex;
  flex: 1 1 auto;
  align-items: flex-end;
}
.price {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #6a92a4;
  margin-right: 8px;
}
.count {
  font-size: 14px;
  color: rgba(255, 124, 124, 1);
  line-height: 20px;
}
.count img {
  display: inline-block;
  width: 11px;
  margin: 0 4px;
}
.labels {
  display: flex;
  margin-left: auto;
}
.labels li {
  height: 24px;
  line-height: 24px;
  border-radius: 4px;
  border: 1px solid rgba(106, 146, 164, 1);
  font-size: 12px;
  color: #6a92a4;
  padding: 0 7px;
  margin-right: 7px;
}

/* video start*/
/* .video {
  display: block;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  position: relative;
}
.video .img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px 8px 0px 0px;
}
.video .content {
  padding: 12px 16px;
}
.video .content h3 {
  font-size: 14px;
  color: #244352;
  line-height: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.video .content p {
  font-size: 12px;
  color: #6a92a4;
  line-height: 17px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  margin-top: 3px;
}
.video .video-detail {
  position: absolute;
  width: 100%;
  height: 200px;
  top: 0;
}
.video .play-icon {
  display: block;
  width: 78px;
  height: 78px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.video .play-count {
  position: absolute;
  bottom: 0;
  height: 32px;
  width: 100%;
  background: linear-gradient(
    360deg,
    rgba(0, 0, 0, 0.65) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  text-align: right;
}
.video .play-count span {
  font-size: 12px;
  color: #ffffff;
  line-height: 32px;
  background: url('/images/goods/video8.png') center left no-repeat;
  padding-left: 18px;
  margin-right: 18px;
} */
/* video end*/
</style>
